module.exports = __webpack_public_path__ + "img/illustrations/shared-library-542f8540a429769c0d9be1f6963722b4.svg";